import { render, staticRenderFns } from "./technical-facts.vue?vue&type=template&id=fd4dbe84&"
import script from "./technical-facts.vue?vue&type=script&lang=js&"
export * from "./technical-facts.vue?vue&type=script&lang=js&"
import style0 from "./technical-facts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports